<template>

  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
<a-layout class="layout">
    <a-layout-header :style="{ position: 'fixed', zIndex: 1, width: '100%' }">
    <common-header/>
    </a-layout-header>
    <a-layout-content class="site-layout-content">
    <router-view/>
    </a-layout-content>
    <a-layout-footer >
    <common-footer/>
    </a-layout-footer>
</a-layout>
    <!-- <Footer></Footer> -->

  </div>
</template>
<script>
import CommonHeader from "./components/Header.vue"
import CommonFooter from "./components/Footer.vue"
export default {
  name: "App",
  components:  {
    CommonHeader,
    CommonFooter,
  },
};
</script>

<style>

.site-layout-content {
  min-height: 280px;
  padding: 0 50px;

  margin-top: 64px;
}

.ant-row-rtl .logo {
  float: right;
  margin: 16px 0 16px 24px;
}

[data-theme="dark"] .site-layout-content {
  background: #141414;
}
.text-h1 {
  display: block;
  font-size: 2em;
  margin:1em;
  margin-left: 0;
  margin-right: 0;
  font-weight: 400;
}

.text-h2 {
  display: block;
  font-size: 1.5em;
margin:0.25em;
  margin-left: 0;
  margin-right: 0;
  font-weight: 400;
}
.text-h3 {
  display: block;
  font-size: 1.17em;

  margin-left: 0;
  margin-right: 0;
  font-weight: 400;
}
.text-h4 {
  display: block;
  font-size: 1em;

  margin-left: 0;
  margin-right: 0;
  font-weight: 400;
}
.text-h5 {
  display: block;
  font-size: 0.83em;

  margin-left: 0;
  margin-right: 0;
  font-weight: 400;
}

.text-h6 {
  display: block;
  font-size: 0.67em;

  margin-left: 0;
  margin-right: 0;
  font-weight: 400;
}
.text-center {
  text-align: center;
}
.text-left {
  text-align: left;
}
.text-right {
  text-align: right;
}
.text-white  {
    color: white
}
.text-theme {
    color: rgb(123 170 74)
}
.text-grey  {
    color: grey
}
body {
  font-size: 14;
}
.flex {
    display: flex;
    flex-direction: row;
}
.flex-center {
    align-content: center;
}
.my-button-container{
  width: 100%;
}
.my-button{
  text-decoration: none;
  text-transform: uppercase;
  margin: 0 0 20px 0;
  text-align: center;
  padding: 7px 14px;
  background-color: #000;
  color: #fff;
  text-transform: uppercase;
  box-shadow: 0 0 1px #000;
  transition-delay: 0.2s;
}
.my-button:hover{
  box-shadow: 0 0 5px #000;
}
.box-shadow:hover{
  box-shadow: 0 10px 13px -6px rgba(0, 0, 0, 0.2), 0 20px 31px 3px rgba(0, 0, 0, 0.14), 0 8px 38px 7px rgba(0, 0, 0, 0.12) !important;
}
.my-card{
  width: 350px;
  max-width: 350px;
  margin-top: 10px;
}

.ant-menu-item:hover, .ant-menu-item-selected {
background-color:rgb(123 170 74) !important;
}
[id]::before {
  content: '';
  display: block;
  height:      64px;
  margin-top: -64px;
  visibility: hidden;
  position: relative;
  z-index: -1;
}

</style>
